import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import { getLanguage } from '../utils/commonFunctions';

// Import translation files
import enTranslations from './locales/en';
import deTranslations from './locales/de';

// Get current language from common utility
const currentLanguage = getLanguage();

// Initialize i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      de: {
        translation: deTranslations,
      },
    },
    lng: currentLanguage, // Use the language from common utility
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  });

// Keep moment locale in sync with i18n (for calendar month/day names)
const getMomentLocale = (lng) => (lng || 'en').split('-')[0];
moment.locale(getMomentLocale(i18n.language));
i18n.on('languageChanged', (lng) => {
  moment.locale(getMomentLocale(lng));
});

export default i18n; 